import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { TFPageContent } from '@tf/shared';
import { createStyles, TFText, Title } from '@tf/ui';
import type React from 'react';

const useStyles = createStyles(() => ({
	date: {
		borderRadius: '24px',
		backgroundColor: '#FFE3CC',
		color: '#6B3407',
		width: 'fit-content',
		padding: '0 .7rem',
		margin: '.3rem 0 1rem 0',
	},
}));

interface Props {
	caseNumber: string;
	dueDate?: string;
}

export const Greetings: React.FC<Props> = ({ caseNumber, dueDate: dueDateRaw }) => {
	const { i18n } = useLingui();
	const { classes } = useStyles();

	const dueDate = dueDateRaw ? i18n.date(dueDateRaw, { dateStyle: 'full' }) : '';

	return (
		<TFPageContent maw="50rem" m="0" flex="1">
			<Title fz="26px" fw="600" order={2}>
				<Trans id="caseRequestPage.title">Case {caseNumber}</Trans>
			</Title>
			<TFText className={classes.date}>
				{dueDate ? (
					<Trans id="caseRequestPage.dueDateNotice">Please submit by {dueDate}, end of the day</Trans>
				) : (
					<Trans id="caseRequestPage.noDueDateNotice">Please submit soon</Trans>
				)}
			</TFText>
		</TFPageContent>
	);
};
